import React, { Component } from 'react';
import { observer } from 'mobx-react';
import SelectPopup from './SelectPopup';
import { switchChannel, getGeoChannel } from '../../../service/command';
import { geoStore } from '../../../mobx/stores/geo';

const channels = new Array(8).fill(1).map((item, index) => index);

class CurrentChannel extends Component {
  componentDidMount() {
    if (!this.props.store.channel) {
      getGeoChannel().then((channel) => {
        this.props.store.channel = channel;
      });
    }
  }

  render() {
    return (
      <div>当前信道：{this.props.store.channel}</div>
    );
  }
}

export default function SwitchChannel() {
  return (
    <SelectPopup
      title="切换信道"
      label="选择信道："
      slot={observer(CurrentChannel)}
      modules={channels}
      store={geoStore}
      defaultSelectValue={channels[1]}
      onConfirm={(channel) => {
        return switchChannel(channel).then(() => {
          geoStore.channel = channel;
        });
      }}
    />
  );
}
